import React, { useContext } from "react";
import styled from "styled-components";
import { ColorVariables } from "manifest-components/src/Colors";
import { getMobileBreakpoint } from "manifest-components/src/Styles/globals";
import { isProdEnvironment } from "../env";
import { VersionContext } from "../context/Version/versionProvider";

const VersionText = styled.p`
  position: fixed;
  top: 50%;
  left: -16px;
  z-index: 100;
  transform: rotate(90deg);
  text-align: center;
  font-weight: bold;
  color: ${ColorVariables.coco3};
  @media (max-width: ${getMobileBreakpoint}) {
    display: none;
  }
`;

export default function DevVersionIndicator() {
  const { initialVersion, firstTimeLoading } = useContext(VersionContext);
  if (isProdEnvironment() || firstTimeLoading) return null;

  return <VersionText>v {initialVersion}</VersionText>;
}
